import React, { CSSProperties, MouseEvent, useRef, useState } from "react";

interface LongPressProps {
  triggerElement: JSX.Element;
  onLongPress?: () => void;
}

const LongPress = ({ triggerElement, onLongPress }: LongPressProps) => {
  const timerRef = useRef<NodeJS.Timeout>();
  const startYRef = useRef<number | null>(null);
  const triggeredRef = useRef(false);
  const [style, setStyle] = useState<CSSProperties>();

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
    setStyle({ opacity: 1 });
  };

  const onTouchStart = (e: TouchEvent) => {
    triggeredRef.current = false;
    startYRef.current = e.touches[0].clientY;
    setStyle({ opacity: 0.65 });

    if (onLongPress) {
      timerRef.current = setTimeout(() => {
        onLongPress();
        triggeredRef.current = true;
      }, 500);
    }
  };

  const onTouchMove = (e: TouchEvent) => {
    const deltaY = Math.abs(e.touches[0].clientY - (startYRef.current ?? 0));
    if (deltaY > 10) clear();
  };

  const onTouchEnd = () => {
    clear();
  };

  const handleOnClick = (e: MouseEvent) => {
    if (triggeredRef.current) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      triggerElement.props.onClick?.(e);
    }
  };

  return React.cloneElement(triggerElement, {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onClick: handleOnClick,
    style: { ...triggerElement.props.style, ...style },
  });
};

export default LongPress;
